import { createApp } from "vue";
import App from "./App.vue";
// Импорт CSS обязателен для отображения карты!
import "ol/ol.css";

// Импортируем и регистрируем плагины
import { Map, Layers, Sources } from "vue3-openlayers";

import './assets/tailwind.css'

const app = createApp(App);
// Глобально регистрируем все компоненты карты
app.use(Map);
app.use(Layers);
app.use(Sources);

app.mount("#app");
